<template>
  <div class="ui-main">
    <a-spin :spinning="loading" size="large">
      <Header :title="isEdit ? '修改预存影院配置' : '新增预存影院配置'" @back="onBack"></Header>
      <a-form style="margin-top: 30px;" ref="formRef" :model="modelRef" @finish="onSubmit">

        <a-form-item label="影院组织" name="organizationId" :rules="[{required: true, message: '必选项不允许为空'}]" v-bind="formItemLayout">
          <a-select v-model:value="modelRef.organizationId" placeholder="请选择影院组织" @change="(id) => getAllCinemaList(id, true)" :disabled="true">
            <!--                    <a-select-option :value="0">全部</a-select-option>-->
            <a-select-option v-for="item in organizationList" :vlaue="item.id" :key="item.id"> {{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="所属影院" name="cinemaId" :rules="[{required: true, message: '必选项不允许为空'}]" v-bind="formItemLayout">
          <a-select v-model:value="modelRef.cinemaId" placeholder="请选择所属影院" @change="onClear" :disabled="true">
            <!--                    <a-select-option :value="0">全部</a-select-option>-->
            <a-select-option v-for="item in cinemaAllList" :vlaue="item.id" :key="item.id"> {{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item name="deductionMode" v-bind="formItemLayout" label="扣款模式" required :rules="[{required: true, message: '必填项不允许为空'}]">
          <a-radio-group v-model:value="modelRef.deductionMode">
            <a-radio :value="1">固定价</a-radio>
            <a-radio :value="2">结算价</a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item v-if="modelRef.deductionMode == 1" name="deductionAmount" v-bind="formItemLayout" label="扣款金额" required :rules="[{required: true, message: '必填项不允许为空'}]">
          <a-input-number v-model:value="modelRef.deductionAmount" :min="0"/>
        </a-form-item>

        <!-- 结算价+-*处理-->
        <a-form-item label="扣款金额" v-if="modelRef.deductionMode == 2" v-bind="formItemLayout">
          <div>
            <a-radio-group :disabled="isSee" v-model:value="modelRef.calculationMethod" button-style="solid">
              <a-radio-button :value="1">加</a-radio-button>
              <a-radio-button :value="2">减</a-radio-button>
              <a-radio-button :value="3">乘</a-radio-button>
            </a-radio-group>
          </div>
          <div class="ui-margin__top20">
            <span class="ui-time__span">扣款金额</span> =
            <span class="ui-time__span">结算价 </span>
            {{ ['','+','-','*'][modelRef.calculationMethod] }}
            <a-input-number :min="0" :disabled="isSee" v-model:value="modelRef.deductionAmount" class="ui-input" placeholder="请输入"></a-input-number>
          </div>
        </a-form-item>

        <a-form-item v-if="fundMode == 2" name="warningValue" v-bind="formItemLayout" label="预警值" required :rules="[{required: true, message: '必填项不允许为空'}]">
          <a-input-number v-model:value="modelRef.warningValue" :min="0"/>
        </a-form-item>

        <a-form-item v-if="fundMode == 2" name="isWarnPlaceOrder" v-bind="formItemLayout" label="达到预警值时允许下单" required :rules="[{required: true, message: '必填项不允许为空'}]">
          <a-radio-group v-model:value="modelRef.isWarnPlaceOrder">
            <a-radio :value="1">是</a-radio>
            <a-radio :value="0">否</a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 12, offset: 6 }">
          <a-button type="primary" html-type="submit" :loading="loading">提交</a-button>
        </a-form-item>
      </a-form>
    </a-spin>
  </div>
</template>

<script>
  import {
    getCinemaDetail,
    updateCinemaDetail
  } from '@/service/modules/preStoreCenter';

  import { getOrganizationList, getCinemaList } from '@/service/modules/cinema.js';
  import Header from '@/components/header/header.vue';

  export default {
    components: { Header },
    props: {
      isEdit: {      // true :编辑  false: 新增
        type: Boolean,
        default: false
      },
      isSee: {      // true :编辑  false: 新增
        type: Boolean,
        default: false
      },
      id: {
        type: Number,
        default: 0
      },
      fundMode: {
        type: Number,
        default: 0
      },
    },
    data() {
      return {
        loading: false,
        modelRef: {
          organizationId: 0,
          cinemaId: 0,
        },
        formItemLayout: {
          labelCol: { span: 6 },
          wrapperCol: { span: 14 },
        },
        cinemaAllList: [],
        organizationList: [],
      }
    },
    created() {
      this.getOrganizationList();
      if(this.isEdit && this.id) {
        this.getData();
      }
    },
    watch: {

    },
    methods: {
      onBack() {
        this.$emit('back');
      },
      async getOrganizationList() {
        let ret = await getOrganizationList({
          page: 1,
          pageSize: 999999
        });
        if (ret.code === 200) {
          this.organizationList = ret.data.list;
          this.getAllCinemaList();
        }
      },
      async getAllCinemaList(organizationId, isClear) {
        if (isClear) {
          this.cinemaAllList = [];
          this.modelRef.cinemaId = undefined;
          this.onClear();
        }
        let ret = await getCinemaList({
          page: 1,
          pageSize: 999999,
          organizationId: organizationId ? organizationId : undefined
        })
        if (ret.code === 200) {
          this.cinemaAllList = ret.data.list;
        }
      },
      async getData() {
        let {data} = await getCinemaDetail({
          id: this.id,
        });
        this.modelRef = data;
      },
      onSubmit() {
        this.$refs.formRef.validateFields().then(async () => {
          try {
            const postData = JSON.parse(JSON.stringify(this.modelRef));
            if (!this.modelRef.deductionAmount && this.modelRef.deductionAmount !== 0) {
              return this.$message.error('请填写扣款金额');
            }
            const ret = await updateCinemaDetail(postData);
            if (ret.code === 200) {
              this.$message.success('保存成功');
              this.onBack();
            }
          } catch (e) {}
        });
      },
    }
  }
</script>

<style scoped>
    .ui-main {
        width: 700px;
        text-align: left;
    }
    .ui-input {
        width: 180px;
        display: inline-block;
    }

    .ui-margin__top20 {
        margin-top: 20px;
    }
</style>
